export default {
    'Orders': [
       'Account', 'Cancellation', 'Payments', 'Promo Code', 'Returns & Refunds', 'Shipping', 'Status' 
    ],
    'Company': [
        'Amersports Information', 'Careers', 'Counterfeit', 'Events', `Feedback on Arc'teryx`, 'Issue On The Website', 'Media Inquiry', 'Personal Data Management', 'Sponsorship', 'Sustainability'
    ],
    'Product Information': [ 'Availability On Brand Website', 'Availability On Retail Store', 'Collection', 'Product Feedback', 'Product Naming Scheme', 'Sizing', 'Technical Information', 'Where Can I Buy?' ],
    'Product Service': [ 'Limited Warranty Coverage', 'Product Recall', 'Product Service Status', 'ReCARE' ]
}